import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import Select from "../../form/select/Select";
import MultiSelect from "../../form/select/MultiSelect";
import moment from "moment/moment";

export const filterSpecificOffice = (offices, applied_offices) => {
  return offices
    ?.filter((item, i) =>
      applied_offices?.some(
        (office) => item?.id === parseInt(office?.office_id)
      )
    )
    .map((value) => ({
      label: value?.office_name,
      value: value.id,
    }));
};

const Settings = ({
  policy,
  edit,
  values,
  errors,
  touched,
  handleBlur,
  handleChange,
  setFieldValue,
  getFieldProps,
  setFieldTouched,
}) => {
  const {
    offices: { offices },
  } = useSelector((state) => state?.office);

  const rabRef = useRef();
  const subOfficeRef = useRef(null);
  const soRef = useRef(null);

  useEffect(() => {
    // controls the switching of the radio buttons on settings tab.
    // Also clearing of fields previously selected but later unselected
    if (values?.apply_to === "RAB") {
      setFieldTouched("specific_offices", false);
      setFieldValue(
        "r_a_b",
        policy?.p_setting[0]?.r_a_b === "nil" ? "" : policy?.p_setting[0]?.r_a_b
      );
      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_setting[0]?.apply_to_sub_offices
      );
      setFieldValue(
        "specific_offices",
        filterSpecificOffice(offices, values.applied_offices)
      );
      setFieldValue("company_wide", policy?.p_setting[0]?.company_wide);
    } else if (values?.apply_to === "CW") {
      setFieldTouched("r_a_b", false);
      setFieldValue("r_a_b", policy?.p_setting[0]?.r_a_b);
      if (values?.apply_to_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_setting[0]?.apply_to_sub_offices
      );
      setFieldValue(
        "specific_offices",
        filterSpecificOffice(offices, values.applied_offices)
      );
      setFieldTouched("specific_offices", false);
      setFieldValue("company_wide", 1);
    } else {
      setFieldTouched("r_a_b", false);
      setFieldValue("r_a_b", policy?.p_setting[0]?.r_a_b);

      setFieldValue(
        "apply_to_sub_offices",
        policy?.p_setting[0]?.apply_to_sub_offices
      );
      if (values?.apply_to_sub_offices) {
        subOfficeRef?.current?.click();
      }
      setFieldValue("company_wide", policy?.p_setting[0]?.company_wide);
    }
  }, [values?.apply_to]);

  return (
    <>
      {!edit ? (
        <div>
          <div className=''>
            <b className='mt-3 fw-bolder text-primary-1'>APPLIED OFFICES</b>
            {parseInt(policy?.p_setting[0]?.company_wide) === 1 && (
              <p>Company Wide</p>
            )}
            {policy?.applied_offices?.length ? (
              <div className='mb-1'>
                <strong className='mt-2'>Specific Offices: </strong>
                <div>
                  {filterSpecificOffice(offices, policy?.applied_offices).map(
                    (item, i) => (
                      <span
                        className='bg-primary text-light fs-6'
                        style={{ padding: "4px", margin: "0px 4px" }}
                        key={i}
                      >
                        {item.label}
                      </span>
                    )
                  )}
                </div>
              </div>
            ) : null}
            {policy?.p_setting[0]?.r_a_b !== "nil" ? (
              <>
                <div className='mb-1'>
                  <strong>Region/Area/Branch: </strong>
                  <span>
                    {offices
                      ?.filter(
                        (item) =>
                          parseInt(item?.id) ===
                          parseInt(policy?.p_setting[0]?.r_a_b)
                      )
                      ?.map((item, i) => (
                        <span key={i}>{item.office_name}</span>
                      ))}
                  </span>
                </div>
                <div className='mb-1'>
                  <strong>Apply to Sub-offfices: </strong>
                  <span>
                    {policy?.p_setting[0]?.apply_to_sub_offices === "1"
                      ? "Yes"
                      : "No"}
                  </span>
                </div>
              </>
            ) : null}
          </div>
          {policy?.p_setting[0]?.expires_at && (
            <div className='row'>
              <h5 className='mt-3 fw-bolder text-primary-1'>EXPIRING DATE</h5>
              <span>
                {moment(policy?.p_setting[0]?.expires_at).format("LL")}
              </span>
            </div>
          )}
        </div>
      ) : (
        <div className=''>
          <h5>Apply to (Office)</h5>
          <div className='form-check my-3'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              id='apply_to'
              value='CW'
              onChange={(values) => {
                handleChange(values);
                setFieldValue("company_wide", 1);
              }}
              defaultChecked={values.apply_to === "CW"}
            />
            <label className='form-check-label' htmlFor='company_wide'>
              Company wide
            </label>
          </div>
          <div className='form-check'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='RAB'
              defaultChecked={values.apply_to === "RAB"}
              onChange={handleChange}
              id='apply_to'
            />
            <label className='form-check-label' htmlFor='rab'>
              Region/Area/Branch
            </label>
            {values?.apply_to === "RAB" && (
              <div>
                <Select
                  isError={errors?.r_a_b && touched?.r_a_b}
                  name='r_a_b'
                  ref={rabRef}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  defaultValue={values?.r_a_b}
                  onChange={(selectedOption) =>
                    setFieldValue("r_a_b", selectedOption?.value)
                  }
                  onBlur={() => {
                    handleBlur({ target: { name: "r_a_b" } });
                  }}
                />
                {errors?.r_a_b && touched?.r_a_b && (
                  <p className='text-danger mb-0'>{errors?.r_a_b}</p>
                )}
                <div className='form-check mt-1'>
                  <input
                    className='form-check-input'
                    type='checkbox'
                    value={values?.apply_to_sub_offices}
                    id='apply_to_sub_offices'
                    name='apply_to_sub_offices'
                    onChange={(e) =>
                      setFieldValue("apply_to_sub_offices", e.target.checked)
                    }
                    defaultChecked={values.apply_to_sub_offices === "1"}
                    ref={subOfficeRef}
                  />
                  <label className='form-check-label' htmlFor=''>
                    Apply to sub offices
                  </label>
                </div>
              </div>
            )}
          </div>
          <div className='form-check mt-3'>
            <input
              className='form-check-input me-2'
              type='radio'
              name='apply_to'
              value='SO'
              onChange={handleChange}
              id='apply_to'
              defaultChecked={values?.apply_to === "SO"}
            />
            <label className='form-check-label ' htmlFor='so'>
              Specific Office(s)
            </label>
            {values?.apply_to === "SO" && (
              <div>
                <MultiSelect
                  isError={
                    errors?.specific_offices && touched?.specific_offices
                  }
                  name='specific_offices'
                  field={{ ...getFieldProps("specific_offices") }}
                  data={offices?.map((item, i) => ({
                    label: item?.office_name,
                    value: item?.id,
                  }))}
                  defaultValue={filterSpecificOffice(
                    offices,
                    values.applied_offices
                  )}
                  onChange={setFieldValue}
                  onBlur={() => {
                    handleBlur({ target: { name: "specific_offices" } });
                  }}
                  errors={errors}
                  touched={touched}
                  disabled={values?.apply_to !== "SO"}
                  ref={soRef}
                />
              </div>
            )}
          </div>
          {/* <div className='form-check mt-3'>
            <label className='form-check-label ' htmlFor='so'>
              Add charges
            </label>
            <div>
              <MultiSelect
                isError={errors?.charges && touched?.charges}
                name='charges'
                field={{ ...getFieldProps("charges") }}
                data={charges?.map((item, i) => ({
                  label: item,
                  value: i + 1,
                }))}
                onChange={setFieldValue}
                onBlur={() => {
                  handleBlur({ target: { name: "charges" } });
                }}
                errors={errors}
                touched={touched}
                // ref={soRef}
              />
            </div>
          </div> */}
          <div className='form-check mt-3 mb-4'>
            <label className='form-check-label ' htmlFor='so'>
              Expires at
            </label>
            <div>
              <input
                name='expires_at'
                value={values?.expires_at}
                className='form-control'
                type='date'
                onChange={handleChange}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Settings;
